import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-cond-assign */
var objectType = function objectType(obj) {
  return Object.prototype.toString.call(obj).slice(8, -1);
};
var isDefined = function isDefined(param) {
  return typeof param !== 'undefined';
};
var isUndefined = function isUndefined(param) {
  return typeof param === 'undefined';
};
var isFunction = function isFunction(param) {
  return typeof param === 'function';
};
var isNumber = function isNumber(param) {
  return typeof param === 'number' && !isNaN(param);
}; // eslint-disable-line

var isString = function isString(str) {
  return objectType(str) === 'String';
};
var isArray = function isArray(arr) {
  return objectType(arr) === 'Array';
};
var closest = function closest(target, selector) {
  // closest(e.target, '.field')
  while (target) {
    // eslint-disable-line
    if (target.matches && target.matches(selector)) return target;
    if (target.msMatchesSelector && target.msMatchesSelector(selector)) return target; // eslint-disable-next-line no-param-reassign

    target = target.parentNode;
  }

  return null;
};
var getOffsetRect = function getOffsetRect(elem) {
  // (1)
  var box = elem.getBoundingClientRect();
  var _document = document,
      body = _document.body,
      documentElement = _document.documentElement; // (2)

  var scrollTop = window.pageYOffset || documentElement.scrollTop || body.scrollTop;
  var scrollLeft = window.pageXOffset || documentElement.scrollLeft || body.scrollLeft; // (3)

  var clientTop = documentElement.clientTop || body.clientTop || 0;
  var clientLeft = documentElement.clientLeft || body.clientLeft || 0; // (4)

  var top = box.top + scrollTop - clientTop;
  var left = box.left + scrollLeft - clientLeft;
  return {
    top: Math.round(top),
    left: Math.round(left)
  };
};
var getTotalScroll = function getTotalScroll(elem) {
  var top = 0;
  var left = 0; // eslint-disable-next-line no-param-reassign

  while (elem = elem.parentNode) {
    top += elem.scrollTop || 0;
    left += elem.scrollLeft || 0;
  }

  return {
    top: top,
    left: left
  };
};
var getTransformProps = function getTransformProps(x, y) {
  return {
    transform: "translate(".concat(x, "px, ").concat(y, "px)")
  };
};
var listWithChildren = function listWithChildren(list, childrenProp) {
  return list.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, _defineProperty({}, childrenProp, item[childrenProp] ? listWithChildren(item[childrenProp], childrenProp) : []));
  });
};
var getAllNonEmptyNodesIds = function getAllNonEmptyNodesIds(items, childrenProp) {
  var childrenIds = [];
  var ids = items.filter(function (item) {
    return item[childrenProp].length;
  }).map(function (item) {
    childrenIds = childrenIds.concat(getAllNonEmptyNodesIds(item[childrenProp], childrenProp));
    return item.id;
  });
  return ids.concat(childrenIds);
};
var isInternetExplorer = function isInternetExplorer() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE '); // If Internet Explorer, return version number

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
    return true;
  }

  return false;
};

export { closest, getAllNonEmptyNodesIds, getOffsetRect, getTotalScroll, getTransformProps, isArray, isDefined, isFunction, isInternetExplorer, isNumber, isString, isUndefined, listWithChildren, objectType };
//# sourceMappingURL=utils.js.map
